

import React from 'react';
import Arrow from './arrow';
import { Link } from "react-scroll";
//import lantern from '../../assets/lantern.png'
//import holly from '../../assets/holly.png'


const SliderNew = props => {
  //const { } = props;
  return (
    <div className="home-page-header-image">
      <div className="home-page-inner">
        <div className="home-page-header-content">
          <div className="home-page-header-text">
            <h1 style={{ marginBottom: "20px" }}>Join Us Sundays at 10:00am or 4:30pm</h1>
            <p>Church gatherings have resumed, in accordance with current COVID 19 requirements.</p>
            <p>You're invited to come visit us at 17 Denison St Kingston, or to connect with us through our livestreamed service.</p>
          </div>
          <div className="home-page-header-links">
            <Link to="connect-online" smooth={true} offset={-60}><div className="home-page-header-link-text">Connect to<br />10am Livestream</div></Link>
            <Link to="ministries" smooth={true} offset={-60}><div className="home-page-header-link-text">Connect to<br />Mid-Week Community</div></Link>
            <Link to="look-into-christianity" smooth={true} offset={-60}><div className="home-page-header-link-text">Look into the<br /> Christian Faith</div></Link>
            <a href="/Connect" alt=""><div className="home-page-header-link-text">Connection<br />Card</div></a>
          </div>

        </div>
        <Arrow />
      </div>


    </div>

  );


}

export default SliderNew;
